import createTheme from '@signal/theme/createTheme'
import light from './light'
import dark from './dark'

export const lightTheme = createTheme(light)
export const darkTheme = createTheme(dark)

export default darkTheme
